import { toast } from "react-toastify";
import { PROVEEDORES_API } from "../views/MainLayout/components/shared/services/proveedores";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialProveedores = []

export const proveedoresReducer = (state = initialProveedores, action) => {
    switch(action.type){
        case "proveedores/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchProveedores = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await PROVEEDORES_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'proveedores/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}